/**
 * Environment configuration
 * Loads API_URL from environment variables
 */

// Get API_URL from Vite environment variables
// Vite automatically loads .env files and exposes VITE_* variables
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002/api';

console.log('🔧 API URL configured:', API_URL);
